import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import i18n from '~/i18n';
import axios from '~/data/http/axios';

//CONNECT TO STORE
@connect((store) => {
    return { user: store.user }
})

export default class DeleteTrackerDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: ''
        }

        this.confirm = this.confirm.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    componentDidMount() {
    }

    closeDrawer() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, "right", null, true));
    }

    async confirm() {
        try
        {
            await axios.delete('/accountMaster/tracker/' + this.props.tracker.id)
            this.props.finished();
        }
        catch (error) {
            this.setState({ error: i18n.t('campaigns:sitetracking.trackingoverview.deleteTrackerError') })
        }
    }


    render() {

        console.log(this.props.tracker)
        return <div>
            <h4 className="mar-b25">{i18n.t('campaigns:sitetracking.trackingoverview.deleteTracker')}Delete Tracker</h4>
            <div className="mar-b10">{i18n.t('campaigns:sitetracking.trackingoverview.deleteTrackerDesc')}</div>
            <div className="mar-b20 text-heavy">{this.props.tracker.host}</div>
            <div className="mar-b25">{i18n.t('campaigns:sitetracking.trackingoverview.deleteTrackerDesc2')}</div>

            {this.state.error && <FormError className="mar-b15" >{this.state.error}</FormError>}

            <div className="quickFlex mar-b20">
                <Button text={i18n.t('campaigns:sitetracking.trackingoverview.deleteTrackerButton')} className="button-primary mar-r10" onClick={this.confirm} />
                <Button text={i18n.t('campaigns:sitetracking.trackingoverview.deleteTrackerCancel')} onClick={this.closeDrawer} />
            </div>

        </div>

    }
};


